import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_ROLE_CLAIMS } from "../../config/connString";
import useAxios from "../../utils/useAxios";
const createRoles = createAsyncThunk(
  "rolesClaims/create-roles",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.post(URL_ROLE_CLAIMS, {
        roleName: data.name,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { createRoles };
